import {Button} from 'antd';
import cn from 'classnames';
import React from 'react';

import {EFieldType} from 'entities/metadata';
import {TEntityValue} from 'modules/data';

import './number-square.less';

interface IOwnProps {
    variant: ENumberSquareVariant;
    value?: TEntityValue;
}

export const NumberSquare = ({value, variant}: IOwnProps) => (
    value ? (
        <Button className={cn('number-square', variant)}>
            {value}
        </Button>
    ) : <></>
);

enum ENumberSquareVariant { PRIMARY = 'primary', DEFAULT = 'default'}

export const FIELD_TYPE_TO_SQUARE_VARIANT_MAP = {
    [EFieldType.NUMBER_SQUARE_PRIMARY]: ENumberSquareVariant.PRIMARY,
    [EFieldType.NUMBER_SQUARE_DEFAULT]: ENumberSquareVariant.DEFAULT,
};
